'use client'

import * as TabsPrimitive from '@radix-ui/react-tabs'

import { useTabsListVariant } from '~/components/component-library/Tabs/context'
import {
  TABS_TRIGGER_BASE_CLASSNAME,
  TABS_TRIGGER_CLASSNAME,
} from '~/components/component-library/Tabs/styles'
import { type TabsTriggerProps } from '~/components/component-library/Tabs/types'
import { cn } from '~/utils/tailwind-utils'

export const TabsTrigger = ({
  ref,
  isDisabled,
  className,
  ...props
}: TabsTriggerProps) => {
  const variant = useTabsListVariant()

  return (
    <TabsPrimitive.Trigger
      ref={ref}
      disabled={isDisabled}
      className={cn(
        TABS_TRIGGER_BASE_CLASSNAME,
        TABS_TRIGGER_CLASSNAME[variant],
        {
          'cursor-not-allowed opacity-40': isDisabled,
          'data-[state=inactive]:hover:text-primary': !isDisabled,
        },
        className,
      )}
      {...props}
    />
  )
}
